import { type ButtonHTMLAttributes } from 'react'

import { GalleryDot } from '@/features/listing/components/gallery-single-item/styled'

type GalleryDotButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  /* Indicates if the button represents a slide that is currently selected. */
  isSelected: boolean
  /* Index of the dot button */
  index: number
}

/**
 * GalleryDotButton is a button component that represents a dot in a carousel or gallery.
 * It indicates the currently selected slide and allows users to navigate to different slides.
 */
export const GalleryDotButton: React.FC<GalleryDotButtonProps> = ({
  isSelected,
  onClick,
  index,
  ...props
}) => {
  // TODO aria-labels as part of KJCA-7063
  return (
    <GalleryDot
      type="button"
      data-testid="gallery-dot"
      onClick={onClick}
      isSelected={isSelected}
      {...props}
    />
  )
}
